import React from 'react'
import '../styles/ScrollDown.css'

const ScrollDown = () => {
  return (
	<div className="field">
		<div className="mouse">
    </div>
	</div>
  )
}

export default ScrollDown